/* eslint-disable quotes */

const overview = {
  tabs: {
    dashboard: 'ダッシュボード',
    message_log: 'メッセージログ',
    atp_log: 'ATP ログ',
    outbound_quarantine: 'アウトバウンド検疫',
    audit_log: '監査ログ',
    review_license: 'ライセンスを確認する',
    domains: 'ドメイン'
  },
  dashboard: {
    title: 'ダッシュボード',
    select_domain: 'ドメインを選択',
    all: '[すべて]',
    time: '時間',
    last_24_hours: '過去 24 時間',
    last_30_days: '過去 30 日間',
    threat_origins: '脅威の起源',
    inbound_email_statistics: '受信メール統計',
    outbound_email_statistics: 'アウトバウンドメール統計',
    total_threat_viruses: '脅威総数/ウイルス数',
    threats_viruses_detected: '脅威/検出されたウイルス',
    dropdown_table: {
      top_recipient_domains: '上位受信者ドメイン',
      top_sender_domains: '上位送信者ドメイン',
      no_data_found: 'データが見つかりません',
      inbound: 'インバウンド',
      outbound: 'アウトバウンド',
      atp: 'ATP',
      none: 'ボリューム',
      volume: 'ボリューム',
      blocked: 'ブロック済み',
      allowed: '許可済み',
      top_recipients_blocked: 'ブロックされた上位受信者',
      top_senders_blocked: '上位送信者がブロックされました',
      last_blocked: '最終ブロック',
      selected_value: {
        none: 'ボリューム',
        blocked: 'ブロック済み',
        allowed: '許可済み',
        recipients: 'ブロックされた上位受信者',
        senders: '上位送信者がブロックされました',
        atp: 'ATP'
      },
      table: {
        RANK: 'ランク',
        DOMAIN: 'ドメイン',
        VOLUME: 'ボリューム',
        BLOCKED: 'ブロック済み',
        RECIPIENTS: '受信者',
        SENDERS: '送信者',
        FILE_NAME: '[ファイル名]',
        FILE_TYPE: 'ファイルタイプ',
        LAST_SEEN: '最後に見たもの'
      }
    },
    charts: {
      overview: '概要',
      allowed: '許可済み',
      file_type: 'ファイルタイプ',
      total_blocked: 'ブロックされた合計数',
      advanced_threats: '高度な脅威',
      sent: '送信済み',
      encrypted: '暗号化済み',
      total_sent: '送信総数',
      total: '合計',
      virus: 'ウイルス',
      viruses: 'ウイルス',
      atp: 'ATP',
      brbl: 'BRBL',
      spam: 'スパム',
      brts: 'BRTS',
      quarantined: '隔離されました',
      blocked: 'ブロック済み',
      blocked_bbl: 'BRBL',
      blocked_spam: 'スパム',
      blocked_brts: 'BRTS',
      blocked_av: 'ウイルス',
      office: 'ミズ・オフィス',
      category: 'カテゴリー',
      percentage: 'パーセンテージ'
    },
    footer: {
      account_id: 'アカウント ID',
      serial_number: 'シリアル番号'
    }
  }
}

/* eslint-enable quotes */

export default overview
